import { ModuleNavTemplateName } from '@efdigital/ll-addon-content';
import type { Module } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui/modifiers/select-value';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Store } from '@warp-drive/core';

import { EditRecord, type EditRecordSignature } from '../edit-record.gts';

const MODULE_NAV_TEMPLATES = Object.entries(ModuleNavTemplateName).map(
  ([key, value]) => ({
    key,
    value,
  })
);

export class EditModuleLayout extends Component<EditRecordSignature<Module>> {
  @service declare store: Store;

  setValue = (property: string, event: Event) => {
    const target = event.target as HTMLSelectElement;
    set(this.args.item, property, target.value);
  };

  <template>
    <EditRecord
      @editLabel="Edit Layout"
      @item={{@item}}
      @context={{@context}}
      ...attributes
    >
      <:form as |uniqueId isDisabled|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          <legend class="gud-eyebrow">Layout</legend>

          <div class="form-group mb-3">
            <label for="{{uniqueId}}-template">Module navigation</label>
            <p class="form-text text-muted">This controls how the user navigates
              around the content within the module.</p>
            <select
              class="form-control"
              id="{{uniqueId}}-template"
              {{selectValue @item.navigation}}
              {{on "change" (fn this.setValue "navigation")}}
            >
              {{#each MODULE_NAV_TEMPLATES as |template|}}
                <option value={{template.value}}>{{template.key}}
                  ([{{template.value}}])</option>
              {{/each}}
            </select>
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
